var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowExternalLoginButtonArea)?_c('section',[_c('external-login',{attrs:{"brands":_vm.brandsMaybeEnableExternalLogin,"redirect-endpoint":_vm.redirectEndpoint}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }